module.exports = __webpack_public_path__ + "static/img/book1.ad931f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book1.png
// module id = AqGP
// module chunks = 1